import "./Landingpage.scss";
import Tabs from "../common/Tabs";
import RecentProjects from "../RecentProjects";
import React, { useEffect, useState } from "react";
import DashBoardHeader from "../common/DashboardHeader";
import useProjectFacade from "../../facade/project.Facade";
import { UpdatePinStatusPayload } from "../../models/Myprojects";
import Drawer from "../common/Drawer";
import MyProjects from "../myprojects";
import PinnedProjects from "../pinnedprojects";
import OtherProjects from "../otherprojects";
import Modal from "../common/Modal";
import TextInput from "../common/textinput";
import { myProjects } from "../../store/model/MyProjects";
import Header from "../common/Header";
import { useAppDispatch, useAppSelector } from "../../store/hooks/StoreHooks";
import Notification from "../common/notification";
import Loader from "../common/loader";
import useProjectTabFacade from "../../facade/calculation/calculation-input/projectTab.Facade";
import CreateProject from "../common/project-create";
import { useNavigate } from "react-router-dom";
import { resetProjectState } from "../../store/dashboard/CreateProjectSlice";
import { getGlobalTemplate, updateSelectedProject } from "../../store/dashboard/ProjectsSlice";
import useCalculationFacade from "../../facade/calculation/calculation.facade";
import useCreateProjectFacade from "../../facade/createProject.Facade";
import NoDataIcon from "../../assets/icons/NoDataFound";
import { resetProjectHeader } from "../../store/calculation/calculation-input/ProjectHeaderSlice";
import SelectCreate from "../common/select-create";
import { setContact } from "../../store/dashboard/CreateProjectSlice";
import ChipsDropdown, { OptionsProps } from "../common/chips-dropdown";
import useJetliftCalculationFacade from "../../facade/jetlift/jetliftCalculations.facade";

const projectDataInitialStates = {
  SortDto: { Field: "UpdatedOn", Order: "DESC" },
  Filters: [],
  GlobalFilter: "",
  PageNumber: 1,
  PageSize: 10,
};
const initialFormState = {
  unitOfMeasure: "imperial",
  customTemplate: "",
  projectName: "",
  caseName: "",
  customerName: "",
  customerContact: "",
  equipmentOffering: "",
  error: "",
  wellName: "",
  country: 0,
  stateName: "",
  county: 0,
};

type FormData = typeof initialFormState;
type projectDataInitalsStates = typeof projectDataInitialStates;

const LandingPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [copyRecord, setCopyRecord] = useState<myProjects[] | any>({});
  const dispatch = useAppDispatch();
  const [isOpenRemoveModal, setIsOpenRemoveModal] = useState<boolean>(false);
  const [inputTimeout, setInputTimeout] = useState<NodeJS.Timeout | null>(null);
  const [notification, setNotification] = useState({
    type: "",
    message: "",
    show: false,
  });
  const { customerEnabled } = useAppSelector((state) => state?.auth);
  const { projectReadOnly } = useAppSelector((state) => state.projectHeader);
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [formData, setFormData] = useState<FormData>(initialFormState);
  const [filteredCases, setFilteredCases] = useState([] as { value?: string, name?: string }[]);
  const [currentParams, setCurrentParams] = useState<projectDataInitalsStates>(
    projectDataInitialStates
  );
  const [selectedOption, setSelectedOption] = useState<OptionsProps[] | undefined>(undefined);


  const [previousParams, setPreviousParams] =
    useState<projectDataInitalsStates>(projectDataInitialStates);
  const [copyProject, setCopyProject] = useState<{
    [key: string]: boolean | number | string | undefined | null | any;
  }>({
    isOpenCopyModal: false,
    projectName: "",
    error: "",
    projectType: "",
  });
  const [currentPage] = useState(1);
  const [pageSize] = useState(40);
  const {
    loadProjectDetails
  } = useCalculationFacade();

  const { otherProjectsData, data, loading, globalTemplate, othersLoading } = useAppSelector(
    (state) => state?.myProjects
  );
  const {
    projectName,
    caseName,
    contact,
    country,
    wellApiNo,
    represtative,
    equiment,
    formation,
    county,
    countyOther,
    customer,
    state,
    well,
    unitMeasurement,
    customerList,
    customerID,
    liftOption,
  } = useAppSelector((state) => state?.createProject);

  const {
    loadCustomerByDetails,
    updateContact,
    updateCustomer,
    updateCustomerID,
    updateCustomerList,
    updateCustomerSearch,
    updateWellSearch,
    updateTemplate,
    updateJetliftProjectID,
  } = useCreateProjectFacade();
  const [projectData, setProjectData] = useState({
    projectName,
    caseName,
    contact,
    country,
    wellApiNo,
    represtative,
    equiment,
    formation,
    county,
    countyOther,
    customer,
    state,
    well,
  });

  useEffect(() => {
    setProjectData({ projectName, caseName, contact, country, wellApiNo, represtative, equiment, formation, county, countyOther, customer, state, well });
  }, [projectName, caseName, contact, country, wellApiNo, represtative, equiment, formation, county, countyOther, customer, state, well]);

  const {
    loadProjects,
    togglePinStatus,
    loadPinProject,
    loadRecentProjects,
    loadOtherProject,
    copyMyProjects,
    copyMyProjectExists,
    removeMyProjects,
    updateGlobalTemplate,
    loadProjectStatus
  } = useProjectFacade();
  const { CopyJetliftProject } = useJetliftCalculationFacade();

  const { getStatesByCountry, getCountryByState } = useProjectTabFacade();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await updateGlobalTemplate();
        await gettingRecentProjects();
        await gettingPinProjects();
        await getStatesByCountry();
        await gettingMyProjects();
        await loadProjectStatusCount();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentParams.GlobalFilter !== "") {
      const getData = setTimeout(() => {
        checkAndFetchProjects(activeTab);
      }, 500);

      return () => clearTimeout(getData);
    } else {
      checkAndFetchProjects(activeTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentParams]);

  const checkAndFetchProjects = (activeTab: number) => {
    if (activeTab === 0) {
      gettingMyProjects();
    } else if (activeTab === 1) {
      fetchOtherProjects();
    }
    setPreviousParams(currentParams);
  };

  const gettingRecentProjects = async (): Promise<void> => {
    try {
      await loadRecentProjects();
    } catch (error) {
      console.log("Error loading projects", error);
    }
  };


  const handleTabChange = (tab: number): void => {
    setActiveTab(tab);
    setCurrentParams({
      SortDto: { Field: "UpdatedOn", Order: "DESC" },
      Filters: [],
      GlobalFilter: "",
      PageNumber: 1,
      PageSize: 10,
    });
  };

  const gettingMyProjects = async () => {
    try {
      await loadProjects(currentParams);
    } catch (error) {
      console.log("Error loading projects", error);
    }
  };

  const fetchOtherProjects = async () => {
    try {
      await loadOtherProject(currentParams);
    } catch (error) {
      console.log("Error loading projects", error);
    }
  };

  const gettingPinProjects = async () => {
    try {
      await loadPinProject();
    } catch (error) {
      console.log("Error loading projects", error);
    }
  };
  const loadProjectStatusCount = async () => {
    try {
      await loadProjectStatus();
    } catch (error) {
      console.log("Error loading projects status", error);
    }
  };

  const handlePinned = async (record: UpdatePinStatusPayload) => {
    try {
      const response = await togglePinStatus({
        projectID: record.projectID,
        stateType: 0,
        value: !record.value,
      });
      if (response) {
        await gettingPinProjects();
        if (activeTab === 0) {
          await gettingMyProjects();
        } else if (activeTab === 1) {
          await fetchOtherProjects();
        }
      }
    } catch (error) {
      console.log("togglePinStatus error", error);
    }
  };

  const handleInputChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCopyProject((prev: any) => ({
      ...prev,
      projectName: event?.target?.value,
    }));
    if (inputTimeout) {
      clearTimeout(inputTimeout);
    }
    const timeoutId = setTimeout(async () => {
      const existsPayload = {
        ProjID: copyRecord?.projectID,
        ProjName: event.target.value,
      };
      try {
        const response = await copyMyProjectExists(existsPayload);
        if (response?.payload === true) {
          setCopyProject((prev: any) => ({
            ...prev,
            error: "Project name already exists.",
          }));
        } else {
          setCopyProject((prev: any) => ({
            ...prev,
            error: "",
          }));
        }
      } catch (err) {
        console.log(err, "error");
      }
    }, 1000);
    setInputTimeout(timeoutId);
  };

  const onChangeSearchCustomer = async (e: any) => {
    const { value } = e.target;
    const keywordCount = value.trim();
    if (keywordCount.length >= 3) {
      updateCustomerSearch(value);
    } else if (keywordCount.length === 0) {
      updateCustomerSearch("");
    }
  };

  const handleOnChangeSelect = async (option: any, name: string = "") => {
    if (name === "customer") {
      if (option?.target?.value) {
        updateCustomer(option?.target?.value);
      } else {
        if (option?.value) await loadCustomerByDetails(option?.value);
        updateCustomer(option?.label);
        updateCustomerID(option?.value);
        updateContact("");
      }
    }
  };

  const handleOnChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;


    if (name === "contact") {
      dispatch(setContact(value));
    }

  };


  const handleCustomerClose = async () => {
    updateCustomerSearch("");
  }

  const handleClearCustomer = () => {
    updateCustomer("");
    updateCustomerID(null);
    updateContact("");
    updateCustomerSearch("");
  }

  const handleCopied = async () => {
    if (copyProject?.projectName) {
      const isJetliftProject =
        copyProject?.projectType === 2 ||
        (typeof copyProject?.projectType === "string" &&
          copyProject.projectType.toLowerCase().includes("jet"));

      const copyPayload = {
        ProjectId: copyRecord?.projectID,
        projectName: copyProject?.projectName,
        IsCaseLevel: false,
        customerCnxId: customerID,
        OperatorContact: contact,
        companyName: customer,
        DisplayCaseName: "Case #1",
        caseProjectId: selectedOption && selectedOption.length > 0 ? selectedOption.map((item) => item.value).join(',') : ''
      };

      const response = isJetliftProject
        ? await CopyJetliftProject({
          ProjectID: String(copyRecord?.projectID ?? ""),
          ProjectName: copyProject?.projectName,
          CaseName: "",
          DisplayCaseName: "Case #1",
          IsCaseLevel: false,
          customerCnxId: Number(customerID ?? 0),
          operatorContact: String(contact ?? ""),
          companyName: String(customer ?? ""),
          parentId: String(copyRecord?.projectID ?? ""),
          CaseProjectId: copyPayload.caseProjectId,
        })
        : await copyMyProjects(copyPayload);

      if (response) {
        setNotification((prev) => ({
          ...prev,
          type: "success",
          message: "Project copied successfully.",
          show: true,
        }));
      }
      setCopyProject((prev: any) => ({
        ...prev,
        isOpenCopyModal: false,
        error: "",
        projectName: "",
        projectType: "",
      }));
      await gettingRecentProjects();
      await gettingPinProjects();
      await loadProjectStatusCount();
      gettingMyProjects();
    }
  };

  const handleRemove = async () => {
    if (copyRecord?.projectID) {
      const payload = {
        Id: copyRecord?.projectID,
      };
      const response = await removeMyProjects(payload);
      if (response) {
        setNotification((prev) => ({
          ...prev,
          type: "success",
          message: "Project deleted successfully.",
          show: true,
        }));
      }
      await gettingRecentProjects();
      await gettingPinProjects();
      await loadProjectStatusCount();
      if (activeTab === 0) {
        await gettingMyProjects();
      } else if (activeTab === 1) {
        await fetchOtherProjects();
      }
      setIsOpenRemoveModal(false);
    }
  };

  const handleDropdown = (selectedOption: string, record: any) => {
    if (
      selectedOption.toLowerCase().trim() === "pinProject".toLowerCase().trim()
    ) {
      handlePinned(record);
    } else if (
      selectedOption.toLowerCase().trim() === "duplicate".toLowerCase().trim()
    ) {
      setCopyProject((prev: any) => ({
        ...prev,
        isOpenCopyModal: true,
        error: "",
        projectType: record?.liftType ?? "",
      }));
      setCopyRecord(record);
      setFilteredCases(
        (record?.caseNameList || []).reduce((acc: any[], curr: any) => {
          if (!acc.some(item => item.name === curr.caseName && item.value === curr.projectID)) {
            acc.push({ value: curr.projectID, name: curr.caseName });
          }
          return acc;
        }, [])
      );



      setSelectedOption(record?.caseNameList && record?.caseNameList.length > 0
        ? [{ value: record.caseNameList[0].projectID, name: record.caseNameList[0].caseName }]
        : []);

      // Set customer details in create project drawer
      const customerData = [...customerList];
      const findCustomer = customerList?.find((item: any) => item.value === record?.customerCnxId);
      if ([0, null]?.includes(record?.customerCnxId) || !findCustomer) {
        customerData.unshift({
          value: record?.customerCnxId ?? null,
          label: record?.companyName,
        });
        if (![0, null]?.includes(record?.customerCnxId))
          updateCustomerList(customerData);
        updateCustomer(customerData[0]?.label);
        updateCustomerID(customerData[0]?.value);
      } else {
        updateCustomer(findCustomer?.label ?? "");
        updateCustomerID(findCustomer?.value ?? "");
      }
      if (![0, null]?.includes(record?.customerCnxId)) {
        updateCustomerList(customerData);
      } else {
        updateCustomerList(customerList);
      }

      updateContact(record?.customerContact);
    } else if (
      selectedOption.toLowerCase().trim() === "remove".toLowerCase().trim()
    ) {
      setIsOpenRemoveModal(true);
      setCopyRecord(record);
    }
  };


  const handleOnChangeCases = (option: any) => {
    setSelectedOption(option);
  }

  const tabs = customerEnabled ? [{
    label: "My projects",
    content: (
      <MyProjects
        currentParams={currentParams}
        setCurrentParams={setCurrentParams}
        handleDropdown={handleDropdown}
        onClick={() => {
          setIsDrawerOpen(true);
          dispatch(resetProjectState());
        }}
      />
    ),
  }] : [
    {
      label: "My projects",
      content: (
        <MyProjects
          currentParams={currentParams}
          setCurrentParams={setCurrentParams}
          handleDropdown={handleDropdown}
          onClick={() => {
            setIsDrawerOpen(true);
            dispatch(resetProjectState());
          }}
        />
      ),
    },
    {
      label: "Other projects",
      content: (
        <OtherProjects
          currentParams={currentParams}
          setCurrentParams={setCurrentParams}
          handleDropdown={handleDropdown}
          onClick={() => {
            setIsDrawerOpen(true);
            dispatch(resetProjectState());
            dispatch(resetProjectHeader())
            dispatch(updateSelectedProject(null));
          }}
        />
      ),
    },
    // {
    //   label: "Comparisons",
    //   content: (
    //     <div className="text-neutral-25 flex flex-col items-center justify-center h-full gap-[8px]">
    //       <NoDataIcon />
    //       Under Construction
    //     </div>
    //   ),
    // },
    // {
    //   label: "Customer revisions",
    //   content: (
    //     <div className="text-neutral-25 flex flex-col items-center justify-center h-full gap-[8px]">
    //       <NoDataIcon />
    //       Under Construction
    //     </div>
    //   ),
    // },
  ];

  const handleConfirm = () => {
    const isDisabled = isOpenRemoveModal ? !copyRecord?.projectID : copyProject?.projectName === "" || copyProject?.error !== "";
    if (isDisabled) return;
    // Store project data in local storage
    const projectData = {
      projectName,
      caseName,
      contact,
      country,
      wellApiNo,
      represtative,
      equiment,
      formation,
      county,
      countyOther,
      customer,
      state,
      well,
    };

    localStorage.setItem("projectData", JSON.stringify(projectData));

    handleCloseDrawer();

    if (isOpenRemoveModal) {
      handleRemove();
    } else {
      handleCopied();
    }
  };

  const handleCloseDrawer = () => {
    updateCustomerSearch("");
    updateWellSearch("");
    setIsDrawerOpen(false);
  };

  const navigate = useNavigate();

  const onConfirm = () => {
    let templateId: string = '';
    if (unitMeasurement === 0 && liftOption?.designType === "ESP") {
      templateId = globalTemplate?.find((gt: any) => gt?.templateName === 'Imperial')?.templateID ?? '';
    } else if (liftOption?.designType === "Jet lift" && unitMeasurement === 0) {
      templateId = globalTemplate?.find((gt: any) => gt?.templateName === 'JetLift')?.templateID ?? '';
      updateJetliftProjectID({ projectID: "", caseID: "", templateID: templateId });
    } else {
      templateId = globalTemplate?.find((gt: any) => gt?.templateName === 'Metric')?.templateID ?? '';
    }
    updateTemplate(templateId);
    dispatch(updateSelectedProject({}));
    navigate(`/project-details/templateID=${templateId}`);

  };

  // useEffect(() => {
  //   let templateId: string = '';
  //   if (unitMeasurement === 0)
  //     templateId = globalTemplate?.find((gt: any) => gt?.templateName === 'Imperial')?.templateID ?? '';
  //   else
  //     templateId = globalTemplate?.find((gt: any) => gt?.templateName === 'Metric')?.templateID ?? '';

  //   updateTemplate(templateId);
  // }, [unitMeasurement]);


  return (
    <>
      <Loader isLoading={loading || othersLoading} />
      <Header />
      <div className="px-[32px] py-[16px]">
        <DashBoardHeader />
        <div className="flex gap-[20px] pb-[20px]">
          <div className="w-[60%]"><RecentProjects /></div>
          <div className="w-[40%]"><PinnedProjects handlePinned={handlePinned} /></div>
        </div>
        <div className="grid grid-cols-1">
          <div
            className="flex items-start flex-col justify-between flex-1 rounded-[8px] border-darkcolor-400 border-[1px] text-neutral-25"
            style={{
              background:
                "var(--Dark-Mode-Gradient-Cards, linear-gradient(181deg, #253240 -16.87%, rgba(37, 48, 64, 0.40) 35.14%))",
            }}
          >
            <Tabs
              tabs={tabs}
              activeTab={activeTab}
              onChange={handleTabChange}
            />
          </div>
        </div>
        <Drawer
          isOpen={isDrawerOpen}
          onClose={handleCloseDrawer}
          width="w-[1174px]"
          title={"Create a project"}
          onConfirm={onConfirm}
          disabled={
            projectName == "" ||
            caseName == ""
          }
        >
          <CreateProject />
        </Drawer>
        {(copyProject?.isOpenCopyModal || isOpenRemoveModal) && (
          <Modal
            width="50%"
            visible={copyProject?.isOpenCopyModal || isOpenRemoveModal}
            onClose={
              isOpenRemoveModal
                ? () => setIsOpenRemoveModal(!isOpenRemoveModal)
                : () => {
                  setCopyProject((prev: any) => ({
                    ...prev,
                    isOpenCopyModal: false,
                    projectName: ""
                  }));
                  handleClearCustomer();
                }
            }
            showButtons={true}
            yesButton="Confirm"
            noButton="Cancel"
            title={isOpenRemoveModal ? "Remove project" : "Copy project"}
            disabled={
              isOpenRemoveModal
                ? copyRecord?.projectID
                  ? false
                  : true
                : copyProject?.projectName === "" ||
                  copyProject?.error !== ""
                  ? true
                  : false
            }
            onConfirm={handleConfirm}
            // onConfirm={isOpenRemoveModal ? handleRemove : handleCopied}
            children={
              isOpenRemoveModal ? (
                <div className="flex justify-center items-center text-neutral-25 p-2">
                  <div className="text-left w-full text-neutral-25 p-2">
                    Are you sure you wish to remove this project from your list?
                  </div>
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-2 gap-2 w-full">
                    <div className="mb-5">
                      <TextInput
                        label="Project name"
                        value={copyProject?.projectName}
                        placeholder="Enter here"
                        onChange={(e) => handleInputChange(e)}
                        error={copyProject?.error} />
                    </div>
                    <div className="mb-5">
                      <label className="text-neutral-25 font-medium mr-2 mb-1">
                        Select cases you would like to copy
                      </label>
                      <ChipsDropdown
                        options={filteredCases}
                        onSelect={(options) => handleOnChangeCases(options)}
                        selectedOptions={selectedOption}
                        disabled={false}
                        disableFirstChipRemove={true}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2 w-full">
                    <div className="">
                      <SelectCreate
                        options={customerList || []}
                        onChange={(option, name) => handleOnChangeSelect(option, name)}
                        padding="px-[14px] sm:py-[10px] py-[5px]"
                        fontSize="16px"
                        className="sm:px-0 px-[10px]"
                        selectedValue={customer}
                        textInput={false}
                        placeholder="Select an operator"
                        label="Operator"
                        name="customer"
                        targetName="customer"
                        showCloseIcon={[0, null, ""]?.includes(customerID) ? false : true}
                        isSearch={true}
                        onChangeSearch={onChangeSearchCustomer}
                        onCloseDropdown={handleCustomerClose}
                        onClear={handleClearCustomer}
                        disabled={true}
                      />
                    </div>
                    <div className="">
                      <TextInput
                        label="Operator contact"
                        placeholder=""
                        value={contact}
                        onChange={(event) => handleOnChangeInput(event)}
                        name="contact"
                        className="flex px-[12px] py-[10px] rounded-[8px] border-[1px] border-darkcolor-400 w-full bg-transparent text-neutral-25 focus:outline-none text-[16px] hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
                      />
                    </div>
                  </div>
                </>
              )
            }
          />
        )}
        <div className="fixed top-4 right-4 z-[1005] flex flex-col space-y-4">
          {notification?.show && (
            <Notification
              isOpen={notification?.show}
              type={notification?.type}
              message={notification?.message}
              onClose={() =>
                setNotification((prev) => ({ ...prev, show: false }))
              }
            />
          )}
        </div>
      </div>
    </>
  );
};

export default LandingPage;
